import React from 'react';
import PropTypes from 'prop-types';
import ScrollToNext from '@components/ScrollToNext';
import img6 from './roundProfileMe.png'
import './style.scss';

const AboutPage = (props, context) => {
  const {
    theme: { colorPrimary, colorHighlight, bgPrimary, textPrimary }
  } = context;

  return (
    <div className="about-page" style={{ backgroundColor: bgPrimary }}>
      <style jsx="true">
        {`
          .highlight {
            background-color: ${colorHighlight};
          }
          ::selection {
            background-color: ${colorHighlight};
          }
        `}
      </style>
      <div className="content-grid">
        <h1 style={{ color: colorPrimary }}>About</h1>
        <div className="about-wrapper">
          <div className="about-content" style={{ color: textPrimary }}>
            <p>
              
            I love tinkering and reverse engineering almost anything. My hunger for knowledge and determination to succeed has contributed to a lifelong of consistent learning and tackling intricate problems. The current technology stacks I'm using are: HTML/CSS, JavaScript, Node.JS, React, jQuery, and Bootstrap; although I'm constantly learning new frameworks, libraries, and technologies. In my spare time I love to fix anything that comes my way, especially when it challenges how far I can think outside of the box.
            </p>
                                 <img src={img6} alt="Nathan Spring" />

          </div>

        </div>
      </div>
      <ScrollToNext pageSelector=".portfolio" />
    </div>
  );
};

AboutPage.contextTypes = {
  theme: PropTypes.any
};

export default AboutPage;



// WEBPACK FOOTER //
// ./src/pages/AboutPage/AboutPage.js